import type { CallsSummaryProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/CallsTab/CallsSummary/index.types';
import {
  MICRO_LABEL,
} from 'Modules/softphone/components/SoftphoneDevTools/styles';
import React from 'react';
import { cn } from '~/lib/utils';

/**
 * CallsSummary - How many calls are on the wire, and in what state
 *
 * Three counters in one row.
 */
export const CallsSummary: React.FC<CallsSummaryProps> = ({
  active,
  onHold,
  incoming,
}) => {
  const tiles = [
    { label: 'Active', count: active },
    { label: 'On hold', count: onHold },
    { label: 'Incoming', count: incoming },
  ];

  return (
    <div className="flex gap-2">
      {tiles.map(({ label, count }) => {
        // A tile only lights up once it is counting something. Zero is the
        // resting state of this panel and must not look like an alert.
        const isLive = count > 0;

        return (
          <div
            key={label}
            className={cn(
              'flex-1 rounded-[9px] border px-2.5 py-[9px]',
              isLive
                ? 'border-emerald-800 bg-emerald-950'
                : 'border-zinc-800 bg-zinc-900'
            )}
          >
            <div className="flex items-baseline gap-1.5">
              <span
                className={cn(
                  'font-sp-mono text-[19px] font-semibold leading-none',
                  isLive ? 'text-emerald-400' : 'text-zinc-400'
                )}
              >
                {count}
              </span>
              <span className={MICRO_LABEL}>{label}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
